export default __webpack_public_path__ + "static/media/comment.700f2be7.svg";